import { useState } from "react";
import { toast } from "sonner";
import { api, apiError } from "../../lib/api";
import { useFetch, Card, Loader, PageHeader, Button } from "../ui";

export default function EmailTemplates() {
  const { data, loading, reload } = useFetch("/admin/delivery/email-templates", []);
  const [edit, setEdit] = useState(null);
  const [form, setForm] = useState({ subject: "", body: "" });
  if (loading || !data) return <Loader />;

  const startEdit = (t) => { setEdit(t.key); setForm({ subject: t.subject, body: t.body }); };
  const save = async (key) => {
    try { await api.put(`/admin/delivery/email-templates/${key}`, form); toast.success("Template saved — used on the next send"); setEdit(null); reload(); } catch (e) { toast.error(apiError(e)); }
  };
  const toggle = async (t) => {
    try { await api.put(`/admin/delivery/email-templates/${t.key}`, { enabled: !t.enabled }); reload(); } catch (e) { toast.error(apiError(e)); }
  };
  const reset = async (key) => {
    if (!window.confirm("Reset this template to the original HughLaunch wording?")) return;
    try { await api.delete(`/admin/delivery/email-templates/${key}`); toast.success("Reset to default"); setEdit(null); reload(); } catch (e) { toast.error(apiError(e)); }
  };

  return (
    <div className="space-y-6">
      <PageHeader eyebrow="Delivery OS" title="Email Templates" subtitle="Edit the wording of every automated email — no code needed. Placeholders like {first_name} fill automatically." />
      <div className="space-y-3">
        {data.templates.map((t) => (
          <Card key={t.key} className="p-4" data-testid={`tpl-${t.key}`}>
            <div className="flex flex-wrap items-center justify-between gap-2">
              <p className="font-bold text-white">{t.name} {t.customized && <span className="ml-1 rounded-full bg-[#C6FF00]/10 px-2 py-0.5 text-[10px] font-extrabold text-[#C6FF00]">CUSTOMIZED</span>}</p>
              <span className="flex items-center gap-2">
                <button data-testid={`tpl-toggle-${t.key}`} onClick={() => toggle(t)} className={`h-6 w-11 rounded-full p-0.5 transition-colors ${t.enabled ? "bg-[#C6FF00]" : "bg-[#23262c]"}`}>
                  <span className={`block h-5 w-5 rounded-full bg-[#0A0C0F] transition-transform ${t.enabled ? "translate-x-5" : ""}`} />
                </button>
                <Button variant="ghost" data-testid={`tpl-edit-${t.key}`} onClick={() => (edit === t.key ? setEdit(null) : startEdit(t))}>{edit === t.key ? "Cancel" : "Edit"}</Button>
              </span>
            </div>
            {edit === t.key ? (
              <div className="mt-3 space-y-2">
                <input data-testid={`tpl-subject-${t.key}`} value={form.subject} onChange={(e) => setForm({ ...form, subject: e.target.value })}
                  className="w-full rounded-xl border border-[#23262c] bg-[#14161b] px-3 py-2.5 text-sm text-white outline-none focus:border-[#C6FF00]" />
                <textarea data-testid={`tpl-body-${t.key}`} rows={6} value={form.body} onChange={(e) => setForm({ ...form, body: e.target.value })}
                  className="w-full rounded-xl border border-[#23262c] bg-[#14161b] px-3 py-2 font-mono text-xs text-white outline-none focus:border-[#C6FF00]" />
                <div className="flex gap-2">
                  <Button data-testid={`tpl-save-${t.key}`} onClick={() => save(t.key)}>Save Template</Button>
                  {t.customized && <Button variant="ghost" data-testid={`tpl-reset-${t.key}`} onClick={() => reset(t.key)}>Reset to Default</Button>}
                </div>
              </div>
            ) : (
              <p className="mt-2 text-sm text-[#8A939B]"><span className="font-bold text-[#c8cdd3]">Subject:</span> {t.subject}</p>
            )}
          </Card>
        ))}
      </div>
      <Card className="p-4 text-xs text-[#6B7280]">Available placeholders: {Object.entries(data.variables).map(([k, v]) => `{${k}} — ${v}`).join(" · ")}. Buttons/links and system emails (receipts, portal invites) stay code-managed for safety.</Card>
    </div>
  );
}
